<template>
  <div class="pick-subcategory">
    <!-- App Bar with Logo -->
    

    <!-- Main Content Container -->
    <v-container fluid   style="max-width: 500px; width: 100%;" class="content-container">
      <!-- Category Selection Title -->
      <v-card class="category-card" flat>
        <!-- Title dynamically adjustable -->
        <v-card-title class="category-title" style="--title-font-size: 24px;">
          Now choose the right Subcategory for your ad:
        </v-card-title>

        <!-- Breadcrumbs Navigation -->
      
        <Breadcrumbs style="max-width: 500px important!; width: 100% importat!;" />
        <!-- Loading State -->
        <v-card-text v-if="loading">
          <v-row class="justify-center">
            <v-col cols="12" class="text-center">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </v-col>
          </v-row>
        </v-card-text>

        <!-- Error State -->
        <v-card-text v-else-if="error">
          <v-alert type="error" class="mb-4">
            {{ error }}
          </v-alert>
          <v-btn color="primary" @click="retryLoading">Retry</v-btn>
        </v-card-text>

        <!-- categories Grid -->
        <v-card-text v-else>
          <v-row class="subcategory-list" dense>
            <!-- Subcategories displayed in a grid with no spacing -->
            <v-col
              v-for="subcategory in subcategories"
              :key="subcategory.id"
              cols="12"
            >
            <v-card
                class="subcategory-card"
                style="--border-opacity: 0.1;"
                elevation="0"
                @click="navigateToGroups(subcategory)"
              >
                <div class="card-content">
                  <span class="subcategory-name">{{ subcategory.title }}</span>
                  <v-icon icon="mdi-chevron-right" class="arrow-icon"></v-icon>
                </div>
              </v-card>
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

const store = useStore();
const router = useRouter();
const route = useRoute();
const loading = ref(false);
const error = ref(null);

// Computed properties
const currentSubCategory = computed(() => route.params.subcategory || "Home");

const subcategories = computed(() => {
  const data = store.state.NewCategory.subcategories;
  console.log("Subcategories in component:", data);
  return data;
});

// Methods
const navigateToHome = () => {
  console.log("Navigating to Home");
  router.push("/");
};


const slugify = (text) =>
  text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')  // Remove non-word chars
    .replace(/\-\-+/g, '-');   // Replace multiple -

const navigateToGroups = (subcategory) => {
  console.log(`Navigating to subcategory: ${subcategory.title}`);

  // Dispatch the selected subcategory to Vuex
  store.dispatch("NewCategory/selectSubCategory", subcategory);

  const selectedCategory = store.getters["NewCategory/selectedCategory"];

  if (!selectedCategory) {
    console.error("No selected category found in Vuex.");
    return;
  }

  // Slugs with fallback
  const categorySlug = selectedCategory.slug || slugify(selectedCategory.name || '');
  const subcategorySlug = subcategory.slug || slugify(subcategory.title || '');

  // Special case: Motors > Cars
  if (categorySlug === "motors" && subcategorySlug === "cars") {
    router.push({ name: "CarSignUpFormForJob" });
    return;
  }

  // Special cases: Land and Multiple Units
  if (subcategorySlug === "land" || subcategorySlug === "multiple-units") {
    router.push({
      name: "GeneralListingSignUpForJob",
      params: {
        categorySlug,
        subcategorySlug,
      },
    });
    return;
  }


  // Default case for Jobs category
  if (categorySlug === "jobs") {
    router.push({
      name: "GeneralListingSignUpForJob",
      params: {
        categorySlug,
        subcategorySlug,
      },
    });
    return;
  }

  // Default navigation for other subcategories to groups list
  router.push({
    name: "GeneralGroupsListComponentForJob",
    params: { subcategorySlug },
    query: { category: categorySlug },
  });
};


const fetchSubCategories = async () => {
  console.log("Fetching subcategories for category:", currentSubCategory.value);
  try {
    loading.value = true;
    error.value = null;

    // Pass the correct categoryId (numeric ID) to the action
    const selectedCategory = store.getters["NewCategory/selectedCategory"];
    if (!selectedCategory || !selectedCategory.id) {
      throw new Error("No selected category found.");
    }

    await store.dispatch("NewCategory/fetchSubCategories", selectedCategory.id);
    console.log("Subcategories fetched successfully:", subcategories.value);
  } catch (err) {
    console.error("Error loading subcategories:", err);
    error.value = "Failed to load subcategories. Please try again.";
  } finally {
    loading.value = false;
  }
};

const retryLoading = () => {
  console.log("Retrying to fetch subcategories");
  fetchSubCategories();
};

// Lifecycle hooks
onMounted(() => {
  fetchSubCategories();
});
</script>


<style scoped>
/* App Bar Styling */
/* Header section with logo stretched and centered */
.app-bar {
  background-color: white;
  border-bottom: 1px solid #e0e0e0;
  height: 60px; /* Increased height */
}

.logo-container {
  display: flex;
  justify-content: center;
  height: 100%;
  padding: 10px 0;
}

.logo-img {
  height: 60px !important; /* Force height */
  width: auto;
  min-width: 200px;
  max-width: 400px; /* Increased max width */
  cursor: pointer;
}

/* Content Container */
/* Centrally aligned content with 50% width on desktop */
.content-container {
  max-width: 50%;
  margin: 0 auto;
  padding-top: 4px;
  padding-bottom: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Align content to the left */
}

/* Breadcrumbs */
/* Styled breadcrumbs with hover transitions */
.breadcrumbs {
  margin-bottom: 4px;
  font-weight: bold;
  font-size: 14px;
  color: #000; /* Black color for Home icon */
  transition: color 0.3s ease;
  text-align: var(--breadcrumbs-align, left); /* Default to left alignment */
  width: auto; /* Adjust width to fit content */
  padding-left: 10; /* Remove extra padding */
  display: flex; /* Ensure proper alignment */
  align-items: flex-start; /* Vertically align items */
  margin-left: 10;
  justify-content: flex-start !important;
}
.breadcrumbs :deep(.v-breadcrumbs-item:hover) {
  color: #b30000; /* Deep red on hover */
}

/* Category Card */
/* Card containing the title and categories */
.category-card {
 background: white;
  border: none !important;
  outline: none !important;
  box-shadow: none !important; /* Optional: remove all shadows */
  width: 100%;
}

.category-title {
  font-size: var(--title-font-size, 24px); /* Default to 24px */
  font-weight: bold;
  padding: 20px 24px 10px;
  color: #333;
  text-align: center;
  /* Add text wrapping properties */

  white-space: normal;
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
  overflow: visible;

}

/* Subcategory List */
/* Grid layout with no spacing between items */
.subcategory-list {
  display: flex;
  flex-direction: column;
}

/* Subcategory Card */
/* Reduced size and hover effect only on text */
.subcategory-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 8px;
  padding: 12px; /* Adjust padding to reduce card size */
  display: flex;
 
  justify-content: space-between;
  align-items: flex-start;
  background-color: white;
 border: none;
}

.subcategory-card:hover .subcategory-name {
  color: #b30000; /* Text turns deep red on hover */
}

.card-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.subcategory-name {
  font-weight: bold;
  font-size: 16px;
}

.arrow-icon {
  color: #757575;
  margin-left: auto; /* Align arrow to the far right */
}

/* Enhanced Responsive Adjustments */
@media (max-width: 768px) {
  /* Full-width container on mobile */
  .content-container {
    max-width: 100%;
    width: 100%;
    padding: 0;
  }
  
  /* Remove border radius on mobile for full-bleed appearance */
  .category-card {
    border-radius: 0;
    box-shadow: none;
  }
  
  /* Adjust title for mobile */
  .category-title {
    font-size: 18px;
    padding: 16px 12px 8px;
    text-align: left;
    line-height: 1.4;
    margin-bottom: 0; /* Remove bottom margin */
  }
  
  /* Reduce spacing after breadcrumbs */
  :deep(.v-breadcrumbs) {
    padding: 0 12px 0;
    margin-bottom: 0;
  }
  
  /* Remove extra padding from card text containing subcategories */
  .category-card .v-card-text {
    padding-top: 8px;
    padding-bottom: 0;
  }
  
  /* Smaller subcategory cards with less padding */
  .subcategory-card {
    padding: 12px 8px;
    border-radius: 0;
    border-left: 0;
    border-right: 0;
    border-top: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  
  .subcategory-name {
    font-size: 14px;
  }
  
  /* Logo adjustments */
  .logo-img {
    min-width: 150px;
    height: 45px !important;
  }
  
  /* App bar height adjustment */
  .app-bar {
    height: 50px;
  }
}

/* Add specific iPhone styles */
@media (max-width: 390px) {
  .category-title {
    font-size: 16px;
  }
  
  .subcategory-name {
    font-size: 13px;
  }
}
</style>